export default __webpack_public_path__ + "static/bm-48e3295a31fadc36ba8c640d850e095f.svg";